import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {JsonEditorComponent} from "ang-jsoneditor";
import {HeadersComponent} from "../../devex/headers/headers.component";
import {ConnecttocrudService} from "../../connecttocrud.service";
import {LeftpanelComponent} from "../../leftpanel/leftpanel.component";
import {ActivatedRoute, Router} from "@angular/router";
import {ConfService} from "../../conf.service";

@Component({
    selector: 'app-teardown',
    templateUrl: './teardown.component.html',
    styleUrls: ['./teardown.component.scss']
})
export class TeardownComponent implements OnInit {

    authModel = [];
    headersData = [];
    prerequisites = [];
    requestBody = {};
    formData = [];
    parameterData = [];
    pathParameter = [];
    responseData = [];
    errorMessage = '';
    responseError = '';
    responses: any;
    responseItems: any;
    requestBodySelected = '';
    @Output() onCompletingTeardownSteps: EventEmitter<any>=new EventEmitter<any>();
    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    @ViewChild(HeadersComponent) headerChild: HeadersComponent;

    @Input() partnerId = localStorage.getItem('partner');
    @Input() accountId = localStorage.getItem('account');
    @Input() executor_name = '';
    @Input() executor_version = '';
    @Input() editFlag: boolean;


    httpOperation;
    httpUrl;
    httpOperations = [
        {'name': 'GET'},
        {'name': 'POST'},
        {'name': 'PUT'},
        {'name': 'PATCH'},
        {'name': 'DELETE'}
    ];
    tearDownStepsList = [];
    tearDownSearchText = '';
    executor;
    executors;

    private devExURL: any;
    private pathParameterSegregator: any;
    private pathParameterStopper: any;
    private pathParameterValue: any;
    private find: any;
    private showPathParameters: any;

    constructor(private _service: ConnecttocrudService, public platform: LeftpanelComponent,private route: ActivatedRoute, public router: Router, private confPost:ConfService) {
    }

    ngOnInit() {

        // this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(res=>{
        //     this.executors = res;
        // });

        // for (const header of this.headersData) {
        //     if (header['key'] === 'Content-Type') {
        //         switch (header['value']) {
        //             case 'multipart/form-data':
        //                 this.requestBodySelected = 'form-data';
        //                 break;
        //             case 'application/x-www-form-urlencoded':
        //                 this.requestBodySelected = 'x-www-form-urlencoded';
        //                 break;
        //             case 'application/json':
        //                 this.requestBodySelected = 'raw';
        //                 break;
        //             default:
        //                 this.requestBodySelected = 'none';
        //                 break;
        //         }
        //     }
        // }
    }


    parameterDataCheck(event: any) {
        // /: calculation
        if (this.devExURL !== event.target.value) {
            this.devExURL = event.target.value;
            this.pathParameterSegregator = this.devExURL.split('/:');
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterStopper = this.pathParameterSegregator[i].split('/');
                this.pathParameterSegregator[i] = this.pathParameterStopper[0];
            }
            // {} for calculation
            let temp2 = this.devExURL.split('/');
            // /: append
            this.pathParameter = [];
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterValue = this.pathParameterSegregator[i];
                this.find = true;
                for (let j = 0; j < this.pathParameter.length; j++) {
                    if (this.pathParameterSegregator[i] === this.pathParameter[j]['key']) {
                        this.find = false;
                    }
                }
                if (this.find === true) {
                    this.pathParameter.push({'key': this.pathParameterValue, 'value': '', 'description': ''});
                }
            }
            // {} append
            for (let i = 2; i < temp2.length; i++) {
                const init = temp2[i].indexOf('{');
                const fin = temp2[i].indexOf('}');
                if ((!(this.pathParameter.some(e => e.key === temp2[i].substr(init + 1, fin - init - 1))) && temp2[i].substr(init + 1, fin - init - 1) !== '') && init !== -1 && fin !== -1) {
                    this.pathParameter.push({
                        'key': temp2[i].substr(init + 1, fin - init - 1),
                        'value': '',
                        'description': ''
                    });
                }
            }
            // confirm to show the path parameter area.
            if (this.pathParameter.length !== 0) {
                this.showPathParameters = true;
            } else {
                this.showPathParameters = false;
            }
        }
    }

    checkQueryParams(event) {
        const tempUrl = event.target.value;
        const seperator = tempUrl.split('/');
        let query: any;
        let finalquery: any;
        if (seperator.length > 0) {
            query = seperator[seperator.length - 1].split('?');
            if (query.length > 1) {
                finalquery = query[query.length - 1].split('&');
                if (finalquery) {
                    for (let i = 0; i < finalquery.length; i++) {
                        let temp = finalquery[i].split('=');
                        let flag = false;
                        for (let j = 0; j < this.parameterData.length; j++) {
                            if (temp[0].includes(this.parameterData[j]['key']) || this.parameterData[j]['key'].includes(temp[0]) || this.parameterData[j]['key'] === temp[0]) {
                                flag = true;
                                if (temp.length > 1) {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = temp[1];
                                } else {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = '';
                                }
                            }
                        }
                        if (flag === false) {
                            if (temp.length > 1) {
                                this.parameterData.push({key: temp[0], value: temp[1], description: ''});
                            } else {
                                this.parameterData.push({key: temp[0], value: '', description: ''});
                            }
                        }
                    }
                }
            }
        }
    }

    getBackgroundStyle(val) {
        if (val === 'GET') {
            return 'get-method';
        } else if (val === 'PUT') {
            return 'put-method';
        } else if (val === 'POST') {
            return 'post-method';
        } else if (val === 'DELETE') {
            return 'delete-method';
        } else {
            return 'get-method';
        }
    }

    getRequestBodyValue(val) {
        switch (val) {
            case 'raw':
                // return JSON.stringify(this.editor.get());
                return this.editor.get();
            case 'binary':
            case 'none':
            default:
        }
    }

    getRequestBody() {
        if (this.requestBodySelected === 'raw') {
            const requestbody = {
                'value': this.getRequestBodyValue(this.requestBodySelected),
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'form-data') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'x-www-form-urlencoded') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'none') {
            const requestbody = null;
            return requestbody;
        }
    }


    toggleExecutor(ev) {
        $('.teardown-executor').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
        //$('fa').toggleClass('fa-chevron-down fa-chevron-up');
    }

    hasTearDownPermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['EDIT_TEAR_DOWN_TEST_SUITE_API', 'test:' + this.partnerId + '=>' + this.accountId + '=>' + this.executor_name + '=>' + this.executor_version]);
        } else {
            return this.platform.hasPlatformPermission('CREATE_TEAR_DOWN_TEST_SUITE_API');
        }
    }

    async executeApi() {
        this.executor['requestBody']=await this.headerChild.getRequestBody();
        const payload = {
            //'executor_name': this.executor_name,
            'executor_type': 'API',
            // 'executor_version': this.executor_version,
            'executor_method_type': this.httpOperation,
            'apiUrl': this.httpUrl,
            'dataroot': null,
            'queryParams': this.parameterData,
            'pathParams': this.pathParameter,
            'headers': this.headersData,
            'requestBody': await this.headerChild.getRequestBody(),
            'prerequisites': null
        };
        // this.onCompletingTeardownSteps.emit(this.executor);
        this.onCompletingTeardownSteps.emit(payload);
        this.platform.openSnackBar('Saved successfully', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
        // this._service.executeApi(payload).subscribe(response2 => {
        //     this.responses = response2;
        //     this.responseItems = JSON.stringify(this.responses.body);
        // });

    }


    onSavingTearDownSteps(payload) {
        this.onCompletingTeardownSteps.emit(payload);
    }

    onAddingExecutor(payload) {
        this.tearDownStepsList.push(payload);
    }

}
